import { Component } from '@angular/core';

@Component({ 
  template: require('./test-connection.component.html'),
  styles: [require('./test-connection.component.scss')]
})
export class TestConnectionComponent {
  ngOnInit() {
    document.getElementById('test-button').onclick = () => this.testConnection();

    
  }

  testConnection() {
    const items = { ...localStorage };
    var ul = document.getElementById('response-list');
    ul.innerHTML = '';
    var startTime, endTime, timeDiff, time;

    startTime = new Date();

    fetch('https://v2gcar23gi.execute-api.us-east-1.amazonaws.com/beta/v2/test-access', {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify(items)
    })
    .then(response => {
      var status = document.createElement('li');
      status.innerText = 'Status Code: ' + response.status.toString();
      ul.appendChild(status);

      endTime = new Date();
      timeDiff = endTime - startTime;
      timeDiff /= 1000;

      time = document.createElement('li');
      time.innerText = 'Time Elapsed: ' + timeDiff + ' ' + 'seconds';
      ul.appendChild(time);

      return response.json();
    })
    .then(jsonData => {
      var data = document.createElement('li');
      data.innerText = 'Response: ' + jsonData.body;
      ul.appendChild(data);

      for (var item in items){
        var li = document.createElement('li');
        li.innerText = item + ': ' + items[item];
        ul.appendChild(li);
      }
    })
    .catch(err => {
      var error = document.createElement('li');
      error.innerText = err;
      ul.appendChild(error);

      endTime = new Date();
      timeDiff = endTime - startTime;
      timeDiff /= 1000;

      time = document.createElement('li');
      time.innerText = 'Time Elapsed: ' + timeDiff + ' ' + 'seconds';
      ul.appendChild(time);

      for (var item in items){
        var li = document.createElement('li');
        li.innerText = item + ': ' + items[item];
        ul.appendChild(li);
      }
    });
  }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/test-connection/test-connection.component.ts